<template>
  <div class="houseList">
    <bv-top></bv-top>
<!--    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply">-->
<!--      补贴标准：房屋面积100平以下1.5万、100-150平2万、150平以上2.5万。-->
<!--    </van-notice-bar>-->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply&&this.ghyt==='10'&&this.fwxz==='2'">
      补贴标准：存量房住宅进行交易的，实行契税先征后补，按照100%全额财政补贴。
    </van-notice-bar>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply&&this.ghyt==='123'">
      补贴标准：中心城区购买符合条件的新建、存量商业类房屋实行契税先缴后补，按照50%补贴。
    </van-notice-bar>
<!--    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="isApply">-->
<!--      补贴款将直接划转到您预留的银行账户，请注意查收。-->
<!--    </van-notice-bar>-->
    <div class="box" v-if="isApply">
      <span class="text" v-if="item.isRemit">
        补贴已发放，请及时查收！
      </span>
      <span class="text" v-if="item.applyStatus==='1'">
        已申请！
      </span>
      <span class="text" v-if="item.applyStatus==='4'">
        完成申请！
      </span>
    </div>
    <van-card :key="item.htId">
      <div class="title" slot="title">
        <div class="titleContent">合同编号：{{item.htbh}}</div>
      </div>
      <div slot="desc">
        <van-cell-group>
          <van-cell title="购房人" :value="item.gfrmc"/>
          <van-cell title="房屋坐落" :value="item.fwzl"/>
          <van-cell title="房屋面积" :value="item.jzmj+'㎡'"/>
          <van-cell title="不动产权证号" :value="item.bdcqzh"/>
          <van-cell title="补贴账户" :value="item.btzh"/>
        </van-cell-group>
      </div>
    </van-card>
    <van-form ref="vanForm" :model="htItem" >
      <van-cell title="申请填报" size="large">
      </van-cell>
      <van-cell-group>
        <van-field
            readonly
            clickable
            name="zhhm"
            :value="htItem.text"
            label="开户人"
            placeholder="请选择补贴账户对应的购房人姓名"
            input-align="right"
            @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="gfrList"
              @confirm="onConfirm"
              value-key="text"
              @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
            name="sjhm"
            v-model.trim="htItem.sjhm"
            clearable
            label="预留手机号"
            placeholder="请输入在银行预留的联系人手机号"
            input-align="right"
            :rules="[{required: true}, {validator:validateMobile, message:'手机号格式不正确'}]"
        />
<!--        <van-field-->
<!--            readonly-->
<!--            clickable-->
<!--            name="ghyt"-->
<!--            :value="htItem.fwxz"-->
<!--            label="房屋性质"-->
<!--            placeholder="请选择房屋规划用途"-->
<!--            input-align="right"-->
<!--            @click="showGhytPickerChange()"-->
<!--            :disabled="fwxzFlag"-->
<!--        />-->
<!--        <van-cell title="房屋性质" >-->
<!--          {{htItem.ghyt | ghytFilter}}-->
<!--        </van-cell>-->
<!--        <van-field-->
<!--            readonly-->
<!--            clickable-->
<!--            name="ghyt"-->
<!--            :value="htItem.fwxz"-->
<!--            label="房屋性质"-->
<!--            input-align="right"-->
<!--        />-->
<!--        <van-field-->
<!--            readonly-->
<!--            label="房屋性质"-->
<!--            input-align="right"-->
<!--        >-->

<!--        </van-field>-->
        <van-cell title="房屋性质" >
          {{this.htItem.ghyt | ghytFilter}}
        </van-cell>
<!--        <van-popup v-model="showGhytPicker" position="bottom">-->
<!--          <van-picker-->
<!--              show-toolbar-->
<!--              :columns="ghytList"-->
<!--              @confirm="onGhytConfirm"-->
<!--              value-key="text"-->
<!--              @cancel="showGhytPicker = false"-->
<!--          />-->
<!--        </van-popup>-->
        <div style="display:inline">

        </div>
      </van-cell-group>
      <van-row type="flex" justify="center" style="width: 100%">
        <van-col span="22" style="text-align: center">
          <van-button type="primary" @click="submitForm">提交申请</van-button>
        </van-col>
      </van-row>
    </van-form>
    <van-dialog v-model="isShow" title="提示" :show-confirm-button="false">
      <van-form @submit="onSubmit" >
        <van-field
            v-model="newBankCard"
            name="newBankCard"
            label="新银行卡号"
            placeholder="新银行卡号"
            :rules="[{pattern,message:'请输入正确的银行卡号'}]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="disabled">提交</van-button>
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
  import Top from '@/views/components/Top'
  import {
    selectQsHtDetail,
    taxQsSubsidiesApply
  } from '@/api/houseResource/fair'
  import '@/styles/maintainFund.scss'
  import {NoticeBar, Dialog} from "vant";
  import { mapGetters } from "vuex";
  import {isMobile} from "vant/lib/utils/validate/mobile";

  export default {
    name: "TaxSubsidiesApply",
    props:{
      imglist:Array,
    },
    filters: {
      ghytFilter(status) {
        // 只有 10 和 10106 显示住宅，其他全部显示非住宅
        const val = status * 1;
        if (val === 10 || val === 10106) {
          return '住宅';
        } else {
          return '非住宅';
        }
      }
    },
    data() {
      return {
        rightImg: require('@/assets/listRight.png'),
        item: {},
        isApply: false,
        htItem: {
          btje:0.00
        },
        gfrList: [],
        ghytList: [
          {text:'住宅',ghyt:'10'},
          {text:'成套住宅',ghyt:'101'},
          {text:'公寓',ghyt:'10103'},
          {text:'普通住宅',ghyt:'10106'},
          {text:'非住宅',ghyt:'12'},
          {text:'商业用房',ghyt:'123'},
          {text:'车库',ghyt:'124'},
          {text:'车位',ghyt:'125'},
          {text:'办公',ghyt:'126'},
          {text:'商务',ghyt:'12604'},
          {text:'小棚',ghyt:'1220'},
          {text:'商业服务',ghyt:'12301'},
          {text:'仓库(工具间)',ghyt:'121904'},
          {text:'其他',ghyt:'13'},
          {text:'其他类型',ghyt:'9999'},
          {text:'仓储',ghyt:'12207'}
        ],
        fwxzFlag:true,
        showGhytPicker:false,
        showPicker: false,
        isShow:false,
        newBankCard:"",
        pattern:/^\d{16,19}$/,
        list: [],
        isShowLoading: false,
        fileList:[],
        fileList2:[],
        fwxz:"0",
        showImg:false,
      }
    },
    components: {
      BvTop: Top,
      VanNoticeBar: NoticeBar,
      ...mapGetters([
        "HOST"
      ]),
    },
    mounted() {
      this.showLoading();
      let htId = this.$route.query.htId;
      this.fwxz = this.$route.query.fwxz;
      this.htItem.ghyt = this.$route.query.ghyt;
      selectQsHtDetail(htId,this.fwxz).then(res => {
        this.item = res.data;
        this.isApply = this.item.isApply;
        this.gfrList = this.item.gfrList;
        this.item = res.data;
        if(this.htItem.ghyt == '10' || this.htItem.ghyt == '10106'){
          this.htItem.fwxz = '住宅';
        }else {
          this.htItem.fwxz = '非住宅';
         // this.fwxzFlag=false;
        }
        this.$toast.clear();
      });
    },
    methods: {
      validateMobile(value) {
        return isMobile(value);
      },
      //全屏加载提示
      showLoading() {
        this.$toast.loading({
          // 持续展示 toast
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      },

      // onGhytConfirm(value) {
      //   this.htItem.fwxz = value.text;
      //   this.htItem.ghyt = value.ghyt;
      //   this.getSubsidy(this.htItem.qsje);
      //   this.showGhytPicker = false;
      // },
      onConfirm(value) {
        this.htItem.text = value.text;
        this.htItem.gfrmc = value.gfrmc;
        this.htItem.zjhm = value.zjhm;
        this.showPicker = false;
      },

      // showGhytPickerChange(){
      //   if(this.fwxzFlag){
      //     this.showGhytPicker = false;
      //   }else {
      //     this.showGhytPicker = true;
      //   }
      // },

      // getSubsidy(amount){
      //   if(amount===null||amount === undefined){
      //     this.htItem.btje = 0;
      //   }else if(this.htItem.ghyt ==="123"){ // 商业
      //     this.htItem.btje = parseFloat(amount/2).toFixed(2)
      //   }else {  //住宅
      //     this.htItem.btje = parseFloat(amount).toFixed(2)
      //   }
      // },

      submitForm() {
          this.showLoading();
          this.htItem.htId = this.$route.query.htId;
          console.log(this.item.applyId);
        let data={
          'htId':this.$route.query.htId,
          'gfrmc':this.htItem.gfrmc,
          'zjhm':this.htItem.zjhm,
          'sjhm':this.htItem.sjhm,
          'qsje':this.htItem.qsje,
          'btje':this.htItem.btje,
          'newBankCard':this.newBankCard,
          'fwxz' : this.fwxz,
          'applyId' : this.item.applyId===null?'':this.item.applyId,
          'ghyt':this.htItem.ghyt
        }
        this.$refs.vanForm.validate().then(() => {
          this.showLoading();
          this.htItem.htId = this.$route.query.htId;
          //console.info(this.htItem);
          taxQsSubsidiesApply(this.fileList, data).then((res) => {
            this.item = res.data;
            this.isApply = this.item.isApply;
            this.gfrList = this.item.gfrList;
            this.fileList = [];
            this.$toast.clear();
            this.$router.push({path: '/personal/subsidies/taxSubsidies'})
          }).catch((res) => {

            if ("99" == res.response.data.code){
            this.$toast.clear();
            Dialog.confirm({
              title: '提示',
              message: '银行卡四要素验证失败，请重新输入新的银行卡',
            }).then(() => {
              this.isShow=true;
            }).catch(()=>{
              this.$toast.clear();
              Dialog.confirm({
                title: '提示',
                message: '银行卡四要素验证失败，请核对手机号、银行卡号后重新提交',
              }).then(() => {
                this.isShow=false;
              }).catch(()=>{
                this.$toast.clear();
              })
            })
            }
            //console.log(this.$toast.clear())
          });
        });
      },
      onSubmit(){
        this.disabled = true;
        let data={
          'keyType': '0036',
          'subType': '003601',
          'catalogCode': '00360101',
          'htId':this.$route.query.htId,
          'gfrmc':this.htItem.gfrmc,
          'zjhm':this.htItem.zjhm,
          'sjhm':this.htItem.sjhm,
          'qsje':this.htItem.qsje,
          'btje':this.htItem.btje,
          'newBankCard':this.newBankCard,
          'fwxz' : this.fwxz,
          'applyId' : this.item.applyId===null?'':this.item.applyId,
          'ghyt':this.htItem.ghyt
        }
        //console.log(this.htItem)
        taxQsSubsidiesApply(this.fileList, data).then((res)=>{
          this.item = res.data;
          this.isApply = this.item.isApply;
          this.gfrList = this.item.gfrList;
          this.fileList = [];
          this.$toast.clear();
          this.$router.push({path: '/personal/subsidies/taxSubsidies'})
        }).catch((res)=>{
          this.$toast.clear();
          if ("99" == res.response.data.code){
            this.$toast.clear();
            Dialog.confirm({
              title: '提示',
              message: '银行卡四要素验证失败，请核对手机号、银行卡号后重新提交',
            }).then(() => {
              this.disabled=false
              this.isShow=true;
            }).catch(()=>{
              this.$toast.clear();
              Dialog.confirm({
                title: '提示',
                message: '银行卡四要素验证失败，请核对手机号、银行卡号后重新提交',
              }).then(() => {
                this.isShow=false;
              }).catch(()=>{
                this.$toast.clear();
              })
            })
          }
        })

      },
      beforeRead(){
        this.clear = true
      },
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    position: absolute;
    font-weight: bold;
    top: 45%;
    left: 46%;
    margin: -20px 0 0 -55px;
    font-size: 35px;
    color: red;
    border: 4px solid red;
    border-radius: 10px;
    z-index: 2000;
    background-color: white;
  }

  .text {
    padding: 10px;
  }
  .uploadDiv {
    float:left;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    padding: 10px 16px;
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    color: #646566;
    white-space: pre-wrap;
    width: 120px;
  }
  .test {
    clear: both;
    box-sizing: border-box;
    padding: 5px 16px;
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    color: #646566;
    white-space: pre-wrap;
    width: 110px;
  }
</style>
